import { AutogenModelMapBrokerageCode, AutogenRowMapBrokerageCode } from "./autogen/AutogenModelMapBrokerageCode";

export class ModelMapBrokerageCode extends AutogenModelMapBrokerageCode<RowMapBrokerageCode> {
	constructor() {
		super(RowMapBrokerageCode);
	}
}

export class RowMapBrokerageCode extends AutogenRowMapBrokerageCode {
}